export const months: any = {
    0: 'Gennaio',
    1: 'Febbraio',
    2: 'Marzo',
    3: 'Aprile',
    4: 'Maggio',
    5: 'Giugno',
    6: 'Luglio',
    7: 'Agosto',
    8: 'Settembre',
    9: 'Ottobre',
    10: 'Novembre',
    11: 'Dicembre'
}

export const monthsArray = Object.keys(months).map(ele => ({[ele]: months[ele]}))
export const monthsArrayOpt = Object.keys(months).map(ele => ({label: months[ele], value: ele}))